<template>
  <el-dialog v-bind="$attrs">
    <p class="tips">
      <i class="el-icon-warning" style="color: #f8b762; margin: 0 10px"></i>
      将签署位置批量放置在指定页面的同一位置，每份文件单个签署方最多可设置30个签署位置
    </p>
    <el-form ref="ApplyFormRef" label-position="top" :model="ApplyForm" :rules="rules">
      <el-form-item label="选择应用页面" prop="pageMode">
        <el-radio-group v-model="ApplyForm.pageMode" @change="RadioChange">
          <el-radio label="1">全部页面</el-radio>
          <el-radio label="2">奇数页面</el-radio>
          <el-radio label="3">偶数页面</el-radio>
          <el-radio label="4">指定页面</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="指定页面" prop="desi" v-if="ApplyForm.pageMode === '4'">
        <el-input v-model.trim="ApplyForm.desi" placeholder="请输入页码或页码范围，用逗号分隔 例：1，2，4-6"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="$emit('BatchSettinsClose',{status:'close'})">取 消</el-button>
      <el-button type="primary" @click="ApplyAction('submit')">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    props:{
      // 总页数
      items: { type: Number, default: 0 },
      BChapCurr:{type:Object,default:()=>{}},
      VISI:{type:Boolean,default:false}
    },
    data () {
      // 这里存放数据
      return {
        ApplyForm:{
          desi:'',
          pageMode:'1',
        },
        rules:{
          pageMode:[{required: true, message: '请选择应用页面', trigger: 'blur'}],
          desi:[{validator: this.desiValidator, trigger: 'change'}],
        },
      }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {
      VISI(val){
        if(val && this.BChapCurr._ApplyForm){
          this.ApplyForm = {...this.BChapCurr._ApplyForm}
        }
      },
    },
    // 方法集合
    methods: {
      /** 提交 */
      ApplyAction(status){
        if(status === 'submit'){
          this.$refs.ApplyFormRef.validate(valid=>{
            if(valid){
              this.$emit('BatchSettinsClose',{status,ApplyForm:this.ApplyForm});
            }
          })
        }
      },
      /** 指定页面校验方法 */
      desiValidator(rule,value,callback){
        const REG = /^\d+(-\d+)?([，,]\d+(-\d+)?)*$/,
        emptyText = '请输入页码或页码范围，用逗号分隔 例：1，2，4-6',
        exceedText= '已超过当前文件最大页数，请重新设置';
        if (value === '') {
          callback(new Error(emptyText));
        } else if(!REG.test(value)) {
          callback(new Error(emptyText));
        } else if(REG.test(value)){
          const maxNum = Math.max(
            ...value.replace(/[，,-]/g, ',')  // 统一逗号
            .split(',')               // 分割
            .filter(part => part !== '')
            .map(part => +part.trim()) // 去除空格
          ); // 过滤空值;
          maxNum > this.items ? callback(new Error(exceedText)) : callback();
        }
      },
      RadioChange(val){
        if(val !== '4'){
          this.ApplyForm.desi = ''
        }
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>

<style lang='less' scoped>
  // @import url(); 引入公共css类
  .tips{
    background-color: #fff5e6;
    border: 1px solid #ffebcc;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// components/contract-view/components/BatchSettingsPup.vue